"use client";
import { useState, useEffect, useRef } from "react";
import { throttle } from "../constants";

function getBrowserName(userAgent) {
  // Samsung Internet
  if (/samsungbrowser/i.test(userAgent)) return "Samsung Internet";
  // Edge (Chromium)
  if (/edg/i.test(userAgent)) return "Edge";
  // Opera
  if (/opr|opera/i.test(userAgent)) return "Opera";
  // Firefox
  if (/firefox/i.test(userAgent)) return "Firefox";
  // Brave-specific test: look for Brave-specific properties (not guaranteed in all situations)
  if (
    window?.navigator?.brave &&
    typeof window?.navigator?.brave?.isBrave === "function"
  )
    return "Brave";
  // Chrome (not Edge, not Opera, not Brave)
  if (
    /chrome/i.test(userAgent) &&
    !/edg/i.test(userAgent) &&
    !/opr|opera/i.test(userAgent) &&
    !/samsungbrowser/i.test(userAgent)
  ) {
    // Possible Brave fallback (Brave cloaks as Chrome by default) -- test by checking the window.navigator object
    if (navigator.brave) return "Brave";
    return "Chrome";
  }
  // Safari (not Chrome)
  if (
    /safari/i.test(userAgent) &&
    !/chrome/i.test(userAgent) &&
    !/android/i.test(userAgent)
  )
    return "Safari";
  // IE
  if (/msie|trident/i.test(userAgent)) return "Internet Explorer";
  return "Unknown";
}

export const useDeviceInfo = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    isMobileDevice: false,
    isIos: false,
    isMac: false,
    isAndroid: false,
    browser: "Unknown",
    viewport: { width: 0, height: 0 },
  });
  function handleResize() {
    setDeviceInfo((prev) => ({
      ...prev,
      viewport: {
        width: typeof window !== "undefined" ? window.innerWidth : 0,
        height: typeof window !== "undefined" ? window.innerHeight : 0,
      },
    }));
  }
  const throttledResize = useRef(throttle(handleResize, 500));

  useEffect(() => {
    const userAgent =
      navigator?.userAgent || navigator?.vendor || window?.opera;
    const isMobileDevice = /Mobi|Android/i.test(userAgent);
    const isIos = /iPhone|iPad|iPod/i.test(userAgent);
    const isMac = /Macintosh/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);
    const browser = getBrowserName(userAgent);

    setDeviceInfo({
      isMobileDevice,
      isIos,
      isMac,
      isAndroid,
      browser,
      viewport: { width: window?.innerWidth, height: window?.innerHeight },
    });

    window?.addEventListener("resize", throttledResize.current);
    return () => window?.removeEventListener("resize", throttledResize.current);
  }, []);

  return {
    ...deviceInfo,
    isAppleDevice: deviceInfo?.isMac || deviceInfo?.isIos,
    isIos: false,
  };
};
